import { createContext, useContext, useState, useEffect, useCallback } from "react";
import useAxios from '../api/axios';

const AuthContext = createContext({});

const loadStoredAuth = () => {
    try {
        const storedData = localStorage.getItem("userData");

        if (!storedData) {
            return {};
        }

        const parsedData = JSON.parse(storedData);
        return parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)
            ? parsedData
            : {};
    } catch {
        return {};
    }
};

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(loadStoredAuth);

    const api = useAxios();

    const addCompany = (newCompany) => {
        setAuth((prev) => ({
            ...prev,
            companies: [...(Array.isArray(prev?.companies) ? prev.companies : []), newCompany],
        }));
    }

    const setSelectedCompanyID = (companyID) => {
        setAuth((prev) => ({ ...prev, selectedCompanyID: companyID }));
    }

    const deleteCompany = (companyID) => {
        setAuth((prev) => ({
            ...prev,
            companies: Array.isArray(prev?.companies) ? prev.companies.filter((comp) => comp.companyID !== companyID) : [],
            selectedCompanyID: companyID === prev?.selectedCompanyID ? null : prev?.selectedCompanyID,
        }));
    }


    const getCompanies = useCallback(async () => {
        const headers = {
            headers: {
                'Content-type': 'application/json;charset=utf-8'
            }
        };

        if (auth.accessToken) {
            headers.headers['X-Auth-Token'] = auth.accessToken;
        }

        try {
            const response = await api.post('getMyCompanies', {}, headers);
            const companies = response.data;

            setAuth((prev) => ({ ...prev, companies }));
        } catch(err) {
            //var errType = MY_COMPANIES_FAILED;
            if (err.response) {
                //dispatch(returnErrors(err.response.data.msg, err.response.status, 'MY_COMPANIES_LOADED'));
                if(err.response.status === 401) {
                //errType = AUTH_ERROR;
                }
            } 
            else if (err.data) {
                //dispatch(returnErrors(err.data.msg, err.data.htmlCode, 'MY_COMPANIES_LOADED'));
            }
            else {
                //dispatch(returnErrors("Odottamaton virhe: " + err.msg, 404, 'MY_COMPANIES_LOADED'));
            }
            
            //dispatch({ type: errType });    
            return null;    
        }
    }, [api, auth]);

        
  // Save to localStorage whenever data changes
    useEffect( () => {
        if(auth?.accessToken && !auth?.companies) {
        getCompanies();
    }

        if (auth && typeof auth === 'object' && Object.keys(auth).length > 0) {
                localStorage.setItem("userData", JSON.stringify(auth));
        } else {
                localStorage.removeItem("userData");
        }
    }, [auth, getCompanies]);


    function isAdmin () {
        return Boolean(auth?.user?.isAdmin);
    }

    function isAuthenticated () {
        return auth?.user;
    }



    return (
        <AuthContext.Provider value={{auth, setAuth, isAdmin, deleteCompany, setSelectedCompanyID, addCompany, isAuthenticated}}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;